/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".input-error-text[_ngcontent-%COMP%]{color:red;position:absolute}.input-error[_ngcontent-%COMP%]{position:relative}.input-error[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{width:100%;padding-left:.5rem}"];
export { styles as styles };
